
import React, { Component } from 'react';
import { Heading } from 'grommet';

import BackLink from './BackLink';
import Page from './Page';
import OdrudaDetail from '../components/OdrudaDetail';
import ObjectDetail from './ObjectDetail';

class OdrudaDetailPage extends Component {

    componentDidMount() {
        this.props.getOdrudaDetail(this.props.requiredId);
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.odrudaDetail.loading &&
            (this.props.odrudaDetail.id !== nextProps.requiredId)) {
            this.props.getOdrudaDetail(nextProps.requiredId);
        }
    }

    getTitle() {
        return (this.props.odrudaDetail.data && this.props.odrudaDetail.data.attributes && this.props.odrudaDetail.data.attributes.nazev)
            ? this.props.odrudaDetail.data.attributes.nazev
            : 'Detail odrůdy';
}

    render() {
        return (
            <Page>
                <Heading level={1} color="titleColor">{this.getTitle()}</Heading>
                <ObjectDetail objectDetail={this.props.odrudaDetail} >
                    <OdrudaDetail odrudaDetail={this.props.odrudaDetail} />
                </ObjectDetail>

                <BackLink link="/odrudy" title="Zpět na seznam odrůd"/>
            </Page>
        );
    }
}

export default OdrudaDetailPage;
